import React, { useState, useEffect, useCallback } from "react";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { personalInfo } from "../data";

const NAV_LINKS = [
  { label: "About",      href: "#about",      id: "about" },
  { label: "Experience", href: "#experience", id: "experience" },
  { label: "Projects",   href: "#projects",   id: "projects" },
  { label: "Skills",     href: "#skills",     id: "skills" },
  { label: "Contact",    href: "#contact",    id: "contact" },
];

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeId, setActiveId] = useState("");
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 30);
      const doc = document.documentElement;
      const scrolled = doc.scrollTop || document.body.scrollTop;
      const total = doc.scrollHeight - doc.clientHeight;
      setProgress(total > 0 ? (scrolled / total) * 100 : 0);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const sections = NAV_LINKS.map(({ id }) => document.getElementById(id)).filter(Boolean);
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActiveId(entry.target.id);
        });
      },
      { rootMargin: "-40% 0px -55% 0px", threshold: 0 }
    );
    sections.forEach((s) => observer.observe(s));
    return () => observer.disconnect();
  }, []);

  const closeMenu = useCallback(() => setMenuOpen(false), []);

  useEffect(() => {
    const onKeyDown = (e) => { if (e.key === "Escape") closeMenu(); };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [closeMenu]);

  return (
    <>
      <nav className={`navbar${scrolled ? " scrolled" : ""}`}>
        <div className="scroll-progress-bar" style={{ width: `${progress}%` }} />
        <div className="navbar-inner">
          <a href="#hero" className="navbar-brand">AA</a>

          <ul className="navbar-links">
            {NAV_LINKS.map(({ label, href, id }) => (
              <li key={href}>
                <a href={href} className={activeId === id ? "active" : ""}>{label}</a>
              </li>
            ))}
          </ul>

          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <a
              href={personalInfo.github}
              target="_blank"
              rel="noreferrer"
              className="social-link"
              aria-label="GitHub"
            >
              <AiFillGithub />
            </a>
            <a
              href={personalInfo.linkedin}
              target="_blank"
              rel="noreferrer"
              className="social-link"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn />
            </a>

            <a
              href={personalInfo.resumeLink}
              download
              className="navbar-resume-btn"
            >
              Resume
            </a>

            <button
              className="navbar-hamburger"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="Toggle navigation menu"
              aria-expanded={menuOpen}
            >
              <span />
              <span />
              <span />
            </button>
          </div>
        </div>
      </nav>

      <div
        className={`navbar-mobile${menuOpen ? " open" : ""}`}
        role="navigation"
        aria-label="Mobile navigation"
      >
        {NAV_LINKS.map(({ label, href, id }) => (
          <a
            key={href}
            href={href}
            className={activeId === id ? "active" : ""}
            onClick={closeMenu}
          >
            {label}
          </a>
        ))}
        <a
          href={personalInfo.resumeLink}
          download
          onClick={closeMenu}
          style={{ borderTop: "1px solid var(--border-color)", marginTop: "8px", paddingTop: "16px" }}
        >
          Download CV
        </a>
      </div>
    </>
  );
}

export default Navbar;
